/* eslint-disable max-len */
import React from "react";
import MuiButton from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import InfoIcon from "@material-ui/icons/Info";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import RefreshIcon from "@material-ui/icons/Refresh";


const useStyles = makeStyles(() =>
  createStyles({
    button: {
      padding: 4,
      minWidth: 32,
    },
  }));

const getIcon = (type: IconType, size: IconButtonSize) => {
  switch (type) {
    case "info":
      return <InfoIcon fontSize={size} />;
    case "copy":
      return <FileCopyIcon fontSize={size} />;
    case "refresh":
      return <RefreshIcon fontSize={size} />;

    default:
      return <InfoIcon fontSize={size} />;
  }
};

type IconType = "info" | "copy" | "refresh";
type IconButtonSize = "small" | "medium";

export interface IconButtonProps {

  /**
   * Button size (small by default)
   */
  size?: IconButtonSize;

  /**
   * Icon type (info by default)
   */
  type?: IconType

  /**
   * Whether the button should show a loading indicator
   */
  loading?: boolean

  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const IconButton: React.FC<IconButtonProps> = ({
  size = "small",
  type = "info",
  loading = false,
  onClick = () => null,
}: IconButtonProps) => {

  const classes = useStyles();

  return (
    <MuiButton className={classes.button} variant="contained" color="primary" size={size} onClick={onClick}>
      {loading ? <CircularProgress color="inherit" size={24} /> : getIcon(type, size)}
    </MuiButton>
  );
};
